
// Actions
const GENERATE_EMBED_CODE = 'zen/widgetEmbedModal/GENERATE_EMBED_CODE';
const GENERATE_EMBED_CODE_FAILED = 'zen/widgetEmbedModal/GENERATE_EMBED_CODE_FAILED';
const GENERATE_EMBED_CODE_SUCCEEDED = 'zen/widgetEmbedModal/GENERATE_EMBED_CODE_SUCCEEDED';
const RESET_EMBED_CODE = 'zen/widgetEmbedModal/RESET_EMBED_CODE';
const errorMessage = 'An error occurred, please try again.';
const defaultResponsePayload = {
  embeddedWidgetUrl: null
};

const initialState = {
  errorMessage: null,
  embedCodeResponsePayload: defaultResponsePayload,
};


// Reducer
// eslint-disable-next-line complexity
const reducer = (state = Object.assign({}, initialState), action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case GENERATE_EMBED_CODE:
      return {...state, isEmbedCodeLoading: true, errorMessage: null};
    case GENERATE_EMBED_CODE_SUCCEEDED:
      return {...state, isEmbedCodeLoading: false, errorMessage: null, embedCodeResponsePayload: payload};
    case GENERATE_EMBED_CODE_FAILED:
      return {...state, isEmbedCodeLoading: false, errorMessage};
    case RESET_EMBED_CODE: {
      return {
        ...state,
        embedCodeResponsePayload: defaultResponsePayload,
        errorMessage: null,
        isEmbedCodeLoading: false
      };
    }
    default:
      return state;
  }
};

const generateEmbedCode = (payload) => {
  return { type: GENERATE_EMBED_CODE, payload };
};

const generateEmbedCodeSucceeded = (payload) => {
  return { type: GENERATE_EMBED_CODE_SUCCEEDED, payload };
};

const generateEmbedCodeFailed = (payload) => {
  return { type: GENERATE_EMBED_CODE_FAILED, payload };
};

const resetEmbedCode = () => {
  return { type: RESET_EMBED_CODE };
};

export default reducer;
export {

  // Actions
  GENERATE_EMBED_CODE_FAILED,
  GENERATE_EMBED_CODE_SUCCEEDED,
  GENERATE_EMBED_CODE,
  RESET_EMBED_CODE,

  // Action Creators
  generateEmbedCode,
  generateEmbedCodeFailed,
  generateEmbedCodeSucceeded,
  resetEmbedCode,
};
